import Markdown from 'react-markdown'

import { Button, Dialog } from '@/components/ui'

import { APP_RELEASE } from './releaseState'

export function ReleaseNotesDialog({ open, onOpenChange }: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
      title="What’s new in Tunes"
      description={`Version ${APP_RELEASE.version}`}
      size="lg"
      footer={<Button onClick={() => onOpenChange(false)}>Got it</Button>}
    >
      <div className="space-y-3 text-sm leading-relaxed text-text-muted [&_h3]:mt-5 [&_h3]:font-semibold [&_h3]:text-text [&_h3:first-child]:mt-0 [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_strong]:font-medium [&_strong]:text-text [&_code]:break-words [&_code]:text-xs [&_p]:my-2">
        <Markdown
          skipHtml
          allowedElements={['h3', 'h4', 'p', 'ul', 'ol', 'li', 'strong', 'em', 'code', 'a', 'br', 'blockquote']}
          unwrapDisallowed
          components={{
            a: ({ children, href }) => (
              <a href={href} target="_blank" rel="noopener noreferrer" className="break-words text-accent underline underline-offset-2">
                {children}
              </a>
            ),
          }}
        >
          {APP_RELEASE.notes}
        </Markdown>
      </div>
    </Dialog>
  )
}
